import { Position, ToolType } from '../../../shared/types/protocol.ts';


export type PositionOrdering = 'posNr' | 'tool';

const posTypeOrder: (ToolType | 'Visual')[] = ['TG', 'PG', 'CAL', 'MM', 'Other', 'Visual', 'CMM', 'VMM'];
const visualRank = posTypeOrder.indexOf('Visual');
const defaultRank = posTypeOrder.length;


export function sortPositions(positions: Position[], ordering: PositionOrdering): Position[] {
    const compare = ordering === 'posNr'
        ? compareByPositionNumber
        : compareByToolType;
    return positions.sort(compare);
}

function compareByPositionNumber(a: Position, b: Position): number {
    return +a.positionNumber - +b.positionNumber;
}

function compareByToolType(a: Position, b: Position): number {
    const getRank = (pos: Position) => {
        if (pos.type === 'visualInspection') return visualRank;
        const toolRank = pos.toolType ? posTypeOrder.indexOf(pos.toolType) : -1;
        return toolRank === -1 ? defaultRank : toolRank;
    }
    return getRank(a) - getRank(b);
}